import { ColumnTypeEnum } from '@y42/json-schema';

export const createColumnDataType = (data: Partial<ColumnDataType>): ColumnDataType => ({
  name: '',
  icon: '',
  color: '',
  columnType: null,
  ...data,
});

export interface ColumnDataType {
  name: string;
  icon: string;
  color: string;
  columnType: ColumnTypeEnum | null;
}
